import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=0860fa95&scoped=true&"
import script from "./ShowContent.vue?vue&type=script&lang=js&"
export * from "./ShowContent.vue?vue&type=script&lang=js&"
import style0 from "./ShowContent.vue?vue&type=style&index=0&id=0860fa95&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0860fa95",
  null
  
)

export default component.exports